// ./client/components/Reports/Graphs.js
import React from "react";
import { useAppContext } from "../../context/appContext";
import { getReportOptions, getDatasetTypes, getDatasetConfigs } from "../../utils/reportConfigs.js";
import { processAllDatasets } from "../../utils/reportData.js";
import { getRecords } from "../../utils/reportRecords.js";
import BaseStats from "../../utils/reportStats.js";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

function BusinessReports() {
  ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

  const { reports, prices, lists } = useAppContext();

  const yearsOffset = 1;
  const records = getRecords(0, reports);
  const previousRecords = getRecords(yearsOffset, reports);

  // Get all records and build data for each category needed for reports
  const standardData = records && processAllDatasets(records, reports, prices, lists);
  const previousData =
    previousRecords && processAllDatasets(previousRecords, reports, prices, lists, yearsOffset);
  console.log("standardData:", standardData);
  console.log("previousData:", previousData);

  const options = getReportOptions(reports);
  const datasetConfigs = getDatasetConfigs({
    reports,
    standardData,
    previousData,
    lists
  });
  console.log("datasetConfigs:", datasetConfigs);
  
  const datasetTypes = getDatasetTypes({ reports, lists });
  console.log("datasetTypes:", datasetTypes);
  
  const myData = {
    labels: standardData?.base.labels,
    datasets: datasetConfigs
      .filter((config) => config.condition)
      .map(({ condition, ...rest }) => ({ ...rest, tension: 0.2 })),
  };
  console.log("myData:", myData);

  return (
    <div className="whole graphs">
      {console.log("standardData:", standardData)}
      {!standardData?.base.labels?.length ? (
        <div>Loading...</div>
      ) : (
        <>
          {/* ----- Graphs ------ */}
          {standardData?.base.value?.length > 0 && (
            <Line key={standardData?.base.value[0]} options={options} data={myData} />
          )}

          {/* ----- Totals ----- */}
          <div className="whole flex-parent">
            {standardData?.base.value?.length > 0 &&
              datasetTypes.map((datasetType, i) => {
                return (
                  <>
                    {datasetType.condition && (
                      <BaseStats
                        key={i}
                        data={standardData[datasetType.name]}
                        title={datasetType.title}
                      />
                    )}
                    {reports.includePrevious && (<BaseStats
                      key={"previous" + i}
                      data={previousData[datasetType.name]}
                      title={`Previous ${datasetType.title}`}
                    />
                    )}
                  </>
                );
              })}
          </div>
        </>
      )}
    </div>
  );
}
export default BusinessReports;
